import { SiteConstant } from '../actions/constants/SiteConstant';
const initialState = {
    sites: [],
    site: {},
    oldSite: {},
    isUpdateRes: false,
    filterDateOptions: null,
    totalSiteCount: 0,
    isLoading: false,
};
export const SiteReducer = (state = initialState, action) => {
    switch (action.type) {
        case SiteConstant.GET_FAV_SITELIST:
        case SiteConstant.GET_SITELIST:
            return {
                ...state,
                sites: (action.append && action.sites.page != 1) ? [...state.sites, ...action.sites.list] : action.sites.list,
                filterOptions: action.sites.filterOptions,
                filterDateOptions: action.sites.filterDateOptions,
                totalSiteCount: action.sites.totalcount,
                isUpdateRes: false
            };
        case SiteConstant.GET_SITE:
            // IMP-273: site 불변식 보장 — API 응답이 undefined/null 이어도 {} 유지.
            // state.SiteReducer.site 소비처의 'Cannot read properties of undefined' 크래시 클래스 근본 차단.
            return { ...state, site: action.site || {} };
        case SiteConstant.UPDATE_SITEINFO:
            return {
                ...state,
                sites: state.sites.map(u => u._id == action.site._id ? action.site : u),
                site: action.site
            };
        case SiteConstant.DELETE_SITE:
            return {
                ...state,
                sites: state.sites.filter(u => u._id !== action.delsiteid),
                isUpdateRes: true
            };
        case SiteConstant.CLEAR_UPDATERES:
            return { ...state, isUpdateRes: false };
        case SiteConstant.ADD_SITEINFO:
            return {
                ...state,
                sites: state.sites.map(u => u._id == action.site._id ? action.site : u),
                site: action.site
            };
        case SiteConstant.LOADING:
            return { ...state, isLoading: true }
        case SiteConstant.LOADED:
            return { ...state, isLoading: false }
        default:
            return state
    }
}